/**
 * 健全度管理方式に応じてページを切り替えるルーター
 */
import { Spin } from 'antd';
import { useEffect } from 'react';
import { trpc } from '../lib/api';
import { useCompanyStore } from '../stores/companyStore';
import { DeteriorationPage } from './DeteriorationPage';
import { ManufacturerLifespanPage } from './ManufacturerLifespanPage';

export function DeteriorationPageRouter() {
  const { healthManagementMode, setHealthManagementMode } = useCompanyStore();

  const { data: currentHealthMode, isLoading } = trpc.company.getHealthManagementMode.useQuery();

  useEffect(() => {
    if (currentHealthMode) {
      setHealthManagementMode(currentHealthMode);
    }
  }, [currentHealthMode, setHealthManagementMode]);

  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
      </div>
    );
  }

  const mode = currentHealthMode || healthManagementMode;

  // メーカー耐用年数Verの場合は専用ページを表示
  if (mode === 'manufacturer_lifespan') {
    return <ManufacturerLifespanPage />;
  }

  // 複雑Ver（ワイブル分布）の場合は既存ページを表示
  return <DeteriorationPage />;
}
